export default __webpack_public_path__ + "static/empathymap-434add11a67678b701513dc27b42a6d2.jpg";